// removed by extract-text-webpack-plugin
module.exports = {"component":"_3ngyMoZOOg44oll7GJkf0x","container":"_374cnDNh4iBEhLAoWg4RJZ","hideForMobile":"_19lWVA2TAzk_0QIBZhVH1-","flexContainer":"_1QdXt9ALuzVl5Yg2seKnbh","iconButtonContainer":"jMWbHZLhuCj6FLx6vE6uA","iconButton":"_2azJmi2aUDMaClr8mTNg4_","save":"_2woiAATWpQ2fq7Kbo85-cE","delete":"_3cs6wYLB7o9G0_Cb7s-H0B","hideForDesktop":"_2Mqkh11QHkmC_DPLblc7Wm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Messages/MessageThreadUtilities/MessageThreadUtilities.css
// module id = 1314
// module chunks = 0